

const Accommodations = () => {
  const amenities = [
    {
      icon: "ri-home-4-line",
      title: "Casa Completa",
      description: "4 quartos confortáveis - 4 camas de casal e 1 beliche"
    },
    {
      icon: "ri-ping-pong-line",
      title: "Quadra de Tênis Privativa",
      description: "Quadra Har-Tru para momentos de diversão e esporte"
    },
    {
      icon: "ri-restaurant-line",
      title: "Cozinha Equipada",
      description: "Cozinha completa com todos os utensílios necessários"
    },
    {
      icon: "ri-wifi-line",
      title: "Wi-Fi Gratuito",
      description: "Internet de alta velocidade em toda a propriedade"
    },
    {
      icon: "ri-drop-line",
      title: "Acesso ao Rio",
      description: "Rio cristalino ao lado da casa, perfeito para banhos refrescantes"
    },
    {
      icon: "ri-restaurant-line",
      title: "Área Gourmet",
      description: "Churrasqueira e espaço para refeições ao ar livre"
    },
    {
      icon: "ri-fire-line",
      title: "Firepit",
      description: "Fogueira à luz das estrelas"
    },
    {
      icon: "ri-leaf-line",
      title: "Jardim Privativo",
      description: "Amplo jardim com árvores frutíferas e horta"
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-light text-stone-800 mb-6">
            Acomodações e <span className="text-olive-600">comodidades</span>
          </h2>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed">
            Tudo o que você precisa para uma estadia perfeita, com o conforto de casa 
            e a tranquilidade do campo.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <img 
              src="https://static.readdy.ai/image/d0b3748824a95918108ba1adb67e0e25/7bed04faf30b91ca959007c8e614001d.jpeg"
              alt="Vista externa da casa"
              className="w-full h-96 object-cover rounded-2xl shadow-xl"
            />
          </div>
          <div>
            <h3 className="text-3xl font-light text-stone-800 mb-6">
              Capacidade para até <span className="text-olive-600 font-normal">10 pessoas</span>
            </h3>
            <div className="space-y-4 text-stone-600">
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-olive-100 rounded-full flex items-center justify-center">
                  <i className="ri-hotel-bed-line text-olive-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-medium text-stone-800">4 Quartos</h4>
                  <p className="text-sm">1 suíte + 3 quartos com camas de casal e um beliche</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                  <i className="ri-drop-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-medium text-stone-800">2 Banheiros</h4>
                  <p className="text-sm">Banheiros completos com chuveiro</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                  <i className="ri-home-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <h4 className="font-medium text-stone-800">Edícula</h4>
                  <p className="text-sm">Completa com churrasqueira e ar condicionado</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {amenities.map((amenity, index) => (
            <div key={index} className="bg-stone-50 p-6 rounded-xl hover:shadow-lg transition-shadow duration-300">
              <div className="w-14 h-14 bg-white rounded-full flex items-center justify-center mb-4 shadow-sm">
                <i className={`${amenity.icon} text-2xl text-olive-600`}></i>
              </div>
              <h3 className="font-medium text-stone-800 mb-2">{amenity.title}</h3>
              <p className="text-sm text-stone-600 leading-relaxed">{amenity.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accommodations;


